t = require('app/scripts/views/internal/teacup-with-helpers')('popover_org_logo')

module.exports = ->
  t.p '.error.hide.js-error'

  t.div '.uploader', ->
    t.form '.realfile', { action: '/1/organization/' + t.mustacheVar('id') + '/logo', method: 'post', enctype: 'multipart/form-data' }, ->
      t.input { type: 'hidden', name: 'token', value: '' }
      t.input { type: 'hidden', name: 'format', value: 'http' }
      t.input '.js-upload-logo', { type: 'file', name: 'file', style: 'margin-bottom: 0;', tabindex: '-1' }
    t.a '.button-link.fakefile', ->
      t.icon 'organization', 'upload-a-new-logo'

  t.mustacheBlock 'logoHash', ->
    t.hr()
    t.a '.quiet-button.js-remove-logo', { href: '#' }, ->
      t.format 'remove-logo'
